import i18n, {
  SupportedLanguage,
  supportedLanguages,
} from '../../../../../utils/i18n'
import { Translation } from '../../../data'

/**
 * Retrieves translations for a given configuration key in all supported languages.
 *
 * This function takes a key string and returns an object containing translations
 * for all supported languages. Each key in the returned object is a language code,
 * and its value is the translation of the given key in that language.
 *
 * @param {string} key - The configuration key for which translations are to be retrieved.
 * @returns {Translation} An object mapping supported language codes to their respective translations.
 *
 * @example
 * const translations = getTranslationsForConfig('welcome_message');
 * console.log(translations);
 * // Output might be: { en: 'Welcome', fr: 'Bienvenue', de: 'Willkommen', … }
 */
export function getTranslationsForConfig(key: string): Translation {
  return supportedLanguages.reduce(
    (previousValue: any, currentValue: SupportedLanguage) => {
      return {
        ...previousValue,
        [currentValue]: i18n.t(key, { lng: currentValue }),
      }
    },
    {},
  )
}
